// extracted by mini-css-extract-plugin
export default {"link":"footer_link__TVll0","pagination":"footer_pagination__-edx4","container":"footer_container__XMKcy","informationContainer":"footer_informationContainer__bQ+l5"};